import styled, { css, keyframes } from "styled-components"
import { latencyComp } from "../../../constants"

export const slideUpBehind = keyframes`
  from {
    transform: translate3d(0, 0, -1rem);
  }
  to { 
    transform: translate3d(0, -100%, -1rem);
  }
`
export const expand = keyframes`
  from {
    transform: scale3d(0, 0, 0); 
  }
  to {
    transform: scale3d(1, 1, 1); 
  }
`
export const expandX = keyframes`
  from { 
    transform: scale3d(0, 1, 1); 
  }
  to { 
    transform: scale3d(1, 1, 1); 
  }
`
export const expandY = keyframes`
  from { 
    transform: scale3d(1, 0, 1); 
  }
  to { 
    transform: scale3d(1, 1, 1); 
  }
`

export const fitToParent = css`
  width: 100%;
  height: 100%;
`
export const Panel = styled.div`
  ${fitToParent}
  background-color: ${props => props.bgColor};

  border-radius: 1.5rem;
  box-sizing: border-box;

  font-family: ${props => props.primaryFont}, sans-serif;
  position: relative;

  animation: ${expandY} 0.65s cubic-bezier(0.96, 0.04, .35, .95) both;
  animation-delay: ${latencyComp}s;
  transform-origin: bottom;
  transform-style: preserve-3d;
  
  width: 95%;
  margin-left: 2.5%;
  margin-top: -2.5%;
`
export const Question = styled.div`
  text-align: center;
  color: ${props => props.fontColor};

  height: 20%;

  padding: 1.5%;

  grid-area: question;
`
export const AnswersAndCountdown = styled.div`
  display: grid;
  grid-template-columns: 45% 10% 45%;
  grid-template-rows: 44% 44%;
  grid-template-areas: 
    "top-left center top-right"
    "bottom-left center bottom-right";
  row-gap: 12%;

  /* Answers overflow panel by small amount on each side */
  width: 105%;
  margin-left: -2.5%;
  height: 50%;
`
// TODO: Extract to component
export const ScoreTab = styled.div`
  color: ${props => props.primaryFont};
  background-color: ${props => props.primaryColor};

  display: flex;
  align-items: center;

  font-size: 85%;
  font-weight: 500;
  border-radius: 1.8rem 1.8rem 0 0;
  padding: 0.5% 5% 1.25%;
  position: absolute;
  left: 5%;
  top: 5%;

  animation: ${slideUpBehind} 0.25s 1.9s ease-out both;
  animation-delay: ${latencyComp}s;
`
export const CountdownBubble = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;

  /* Wider and taller than its grid area... */
  width: 150%;
  height: 130%;
  /* ...so must give negative margin to keep centered */
  margin-top: -15%;
  margin-left: -25%;

  grid-area: center;
  z-index: 2;
  position: relative;

  animation: ${expand} 0.4s 2.25s both;
  animation-delay: ${latencyComp}s;
  transform-origin: center;
`

export const ScoreValue = styled.div`
  color: ${props => props.primaryFont};
  margin-left: 10%;
`
export const AnswerWrapper = styled.div`
  font-family: ${props => props.fontName}, sans-serif;
  grid-area: ${props => props.gridArea};
  margin-left: ${props => props.orientation === "right" ? -10 : 0}%;
  width: 110%;

  animation: ${expandX} 0.4s 2.6s both;
  transform-origin: ${props => ({left: "right", right: "left"}[props.orientation])};
  animation-delay: ${latencyComp}s;
`
export const PointsViewWrapper = styled.div`
  width: 100%;
  font-size: 120%;

  /* This places the points just a little below center in the countdown (as in the designs)  */
  position: absolute;
  top: 5%;
  bottom: 0;
`

